exports.globalParamsSchema = {
  token: ''
}
exports.xtdConfigSchema = {
  settlement: 0,
  unSettlement: 0
}
